import React from 'react'
import PropTypes from 'prop-types'
import LogoColor from '../images/logo_color.png'
import LogoWhite from '../images/logo_white.png'

const CompanyLogoRenderer = ({ color, size }) => {
  const styles = {
    maxHeight: '19px',
    maxWidth: '83px'
  }

  let Logo = LogoWhite
  if (color) {
    Logo = LogoColor
  }
  if (size && size === 'login') {
    styles.maxHeight = '65px'
    styles.maxWidth = '240px'
  }
  if (size && size === 'xlarge') {
    styles.maxHeight = '50px'
    styles.maxWidth = '220px'
  }
  if (size && size === 'large') {
    styles.maxHeight = '32px'
    styles.maxWidth = '200px'
  }
  return <img alt="GovDocs Logo" style={styles} src={Logo} />
}

CompanyLogoRenderer.propTypes = {
  color: PropTypes.bool,
  size: PropTypes.string
}

CompanyLogoRenderer.defaultProps = {
  color: false,
  size: null
}

export default CompanyLogoRenderer
